import { gql, useMutation } from '@apollo/client'
import { yupResolver } from '@/gf/lib/yupResolver'
import { useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import * as yup from 'yup'

import FormM from '@/gf/modules/Form'

import Field from '@/gf/components/Field'
import ModalForm from '@/gf/components/ModalForm'
import ShippingCarrierInput from '@/gf/components/next/ShippingCarrierInput'
import TextField from '@/gf/components/TextField'
import { Shipment } from '../../types'

const mutation = gql`
  mutation EditShipment(
    $shipmentId: String!
    $carrier: String
    $trackingNumber: String
    $trackingLink: String
  ) {
    editShipment(
      shipmentId: $shipmentId
      carrier: $carrier
      trackingNumber: $trackingNumber
      trackingLink: $trackingLink
    )
  }
`
const EditShipmentSchema = yup.object({
  carrier: yup.string().label('Shipping Carrier').required().nullable(),
  trackingNumber: yup.string().trim().label('Tracking Number').required().nullable(),
})

type Form = {
  carrier: string | null
  trackingNumber: string | null
}

export default function EditShippingModalForm({
  shipment,
  closeShipmentEdit,
  reloadStoreOrder,
}: {
  shipment?: Shipment
  closeShipmentEdit: () => void
  reloadStoreOrder: () => void
}) {
  const [editShipment] = useMutation(mutation)
  const form = useForm<Form>({
    shouldUnregister: true,
    resolver: yupResolver(EditShipmentSchema),
  })

  useEffect(() => {
    if (shipment) {
      form.reset({
        carrier: shipment.carrier,
        trackingNumber: shipment.tracking,
      })
    }
  }, [shipment])

  return (
    <ModalForm
      open={!!shipment}
      onClose={() => {
        closeShipmentEdit()
      }}
      onSubmit={form.handleSubmit((formData) => {
        editShipment({ variables: { ...formData, shipmentId: shipment?.id } }).then(
          reloadStoreOrder
        )
        closeShipmentEdit()
      })}
      title="Edit Shipping"
    >
      <div className="flex flex-col gap-y-2">
        <Controller
          control={form.control}
          name="carrier"
          render={({ field, fieldState }) => (
            <Field label="Shipping Carrier" errors={fieldState.error?.message}>
              <ShippingCarrierInput
                value={field.value}
                onChange={(carrier) =>
                  form.setValue('carrier', carrier, {
                    shouldValidate: FormM.shouldValidate(form.formState.errors),
                  })
                }
              />
            </Field>
          )}
        />
        <TextField
          label="Tracking Number"
          {...form.register('trackingNumber')}
          placeholder="i.e. 134509253094, 1ZP92387"
          errors={form.formState.errors?.trackingNumber?.message}
        />
      </div>
    </ModalForm>
  )
}
